/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { IntlProvider } from 'react-intl'
import Spanish from '../../i18n/es.json'

const lang = Spanish

const Language = (props) => {
  const formats = {
    dateTime: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'UTC',
    },
  }

  return (
    <IntlProvider messages={lang} locale="es" formats={formats}>
      {props.children}
    </IntlProvider>
  )
}

export default Language
